import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import confetti from 'canvas-confetti';
import '../styles/Complete.css';

const Complete = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!sessionId) {
      navigate('/');
      return;
    }
    setStatus('success');
  }, [sessionId, navigate]);

  useEffect(() => {
    if (status === 'success') {
      // Trigger confetti
      const duration = 3 * 1000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      const randomInRange = (min, max) => Math.random() * (max - min) + min;

      const baseInterval = setInterval(function () {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(baseInterval);
        }

        const particleCount = 50 * (timeLeft / duration);

        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        });
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        });
      }, 250);

      return () => clearInterval(baseInterval);
    }
  }, [status]);

  if (status === 'loading') {
    return (
      <div className="spinner-wrapper">
        <div className="spinner"></div>
        <p className="loading-text">Verifierar betalning...</p>
      </div>
    );
  }

  return (
    <div className="complete-wrapper">
      <div className="complete-card">
        <div className="success-icon-container">
          <div className="checkmark-circle">
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
          </div>
        </div>

        <h1 className="complete-title">Betalningen lyckades!</h1>
        <p className="complete-subtitle">
          Tack för din prenumeration{user?.email ? `, ${user.email}` : ''}! <br />
          Ditt konto är nu aktiverat.
        </p>

        <div className="next-steps-section">
          <h3 className="next-steps-title">Nästa steg — Kom igång</h3>
          <ol className="next-steps-list">
            <li>
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>Gå till Bokningsassistenten</strong>
                <p>
                  Klicka på "Gå till Mitt Konto" och öppna sedan bokningsassistenten från
                  navigeringen.
                </p>
              </div>
            </li>
            <li>
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>Konfigurera dina inställningar</strong>
                <p>Välj fordonstyp, datum, ort och fyll i ditt mobilnummer samt e-post.</p>
              </div>
            </li>
            <li>
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>Starta sessionen &amp; skanna QR</strong>
                <p>
                  Klicka på "Skapa och starta session" och skanna QR-koden med BankID för att logga
                  in på Trafikverket.
                </p>
              </div>
            </li>
          </ol>
        </div>

        <div className="actions">
          <button onClick={() => navigate('/account')} className="btn-primary">
            Gå till Mitt Konto
          </button>
          <button onClick={() => navigate('/')} className="btn-secondary">
            Gå till startsidan
          </button>
        </div>
      </div>
    </div>
  );
};

export default Complete;
